export class HealthOrganizationUser {
    UserId: number;
    IsAssigned: boolean;
   
  }